<template>
  <div class="intro-tabs">
    <n-tabs :default-value="props.value" justify-content="center" :bar-width="170">
      <n-tab v-for="tab in TABS" :key="tab.name" :name="tab.name">
        <locale-link class="custom-tab" :to="`/${tab.name}`">
          {{ tab.text }}
        </locale-link>
      </n-tab>
    </n-tabs>
  </div>
</template>

<script setup lang="ts">
import { NTabs, NTab } from 'naive-ui'

const { t } = useI18n()

const TABS = computed(() => [
  {
    name: 'about',
    text: t('about_us_page_title'),
  },
  {
    name: 'corporation',
    text: t('footer_vender_join_us'),
  },
])

const props = withDefaults(
  defineProps<{
    value?: string
  }>(),
  {
    value: 'about',
  }
)
</script>

<style lang="scss" scoped>
.intro-tabs {
  :deep(.n-tabs) {
    .n-tabs-tab {
      @apply p-0;
    }
    .n-tabs-bar {
      @apply h-1;
    }
    .custom-tab {
      @apply flex justify-center py-18px w-120px sm:w-170px;
    }
  }
}
</style>
